import {
  CircularProgress as MuiCircularProgress,
  CircularProgressProps,
} from '@mui/material';
import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

interface Props extends CircularProgressProps {
  className?: string;
}

const CircularProgressImpl = React.forwardRef<HTMLSpanElement, Props>(
  ({ className, ...props }, ref) => {
    return <MuiCircularProgress className={className} ref={ref} {...props} />;
  }
);

/**
 * Customized MUI CircularProgress component.
 *
 * It inherits all properties of a MUI CircularProgress
 */
export const CircularProgress = muiStyled(CircularProgressImpl)(
  ({ theme }) => css``
);

export default CircularProgress;
